
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarCross as ObiBuoyPilarCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-cross.js';
 
 
 

 
 export const ObiBuoyPilarCross = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-cross',
   elementClass: ObiBuoyPilarCrossElement,
   events: {
     
   }
  });
 
 